import helpers_utm_keys from "~/helpers/signup/utmKeys.js"

export default async function ({ route, app, req }) {
  helpers_utm_keys.forEach((key) => {
    if (typeof route.query[key] === "string")
      app.$cookies.set(key, route.query[key])
  })
  if (req?.headers?.referer?.length > 0 && !app.$cookies.get("referer")) {
    app.$cookies.set("referer", req.headers.referer)
  }
}
